export const SIDE_PANEL_ANIMATION_DURATION_MS = 300;
export const SIDE_PANEL_Z_INDEX = 9999;
